import { RoundNumber } from './round-number';

export const PercentCalculator = () => {
  const { roundTo } = RoundNumber();

  const calculatePercentage = (wholeNumber, partNumber) => {
    if (!Number.isFinite(wholeNumber) || !Number.isFinite(partNumber)) return null;

    if (wholeNumber === 0) {
      return 0;
    }

    return roundTo((partNumber / wholeNumber) * 100);
  };

  const calculateValue = (wholeNumber, percentage) => {
    if (!Number.isFinite(wholeNumber) || !Number.isFinite(percentage)) return null;

    return roundTo((wholeNumber * percentage) / 100);
  };

  return {
    calculatePercentage,
    calculateValue,
  };
};